import Reactotron from 'reactotron-react-js'
//import { reactotronRedux } from 'reactotron-redux'

//TODO: Reactron is not working with the latest react-scripts but obviously maintainers will update the project early 2023 https://github.com/infinitered/reactotron/issues/1235
const reactotron = Reactotron.configure({ name: 'Prolister' })
  //.use(reactotronRedux())
  .connect()

export default reactotron
